// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  memoryId: __t.u64().primaryKey().name("memory_id"),
  versonaId: __t.u64().name("versona_id"),
  tellerId: __t.u64().name("teller_id"),
  originId: __t.u64().name("origin_id"),
  originAt: __t.timestamp().name("origin_at"),
  hops: __t.u8(),
  confidence: __t.u8(),
});
